module.exports = __webpack_public_path__ + "img/flag-belarus.90324cec.png";